// Shared brand component for "Solemnity IT Healthcare Solutions Pvt Ltd".

export const SOLEMNITY_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_quiz-platform-68/artifacts/y8ya19ci_Logo.png";

export const BRAND = {
  short: "Solemnity",
  full: "Solemnity IT Healthcare Solutions Pvt Ltd",
  subtitle: "IT Healthcare Solutions Pvt Ltd",
  tagline: "Delivers Quality",
};

const SIZE = {
  sm: { box: "w-9 h-9", img: "w-7 h-7" },
  md: { box: "w-11 h-11", img: "w-9 h-9" },
  lg: { box: "w-14 h-14", img: "w-12 h-12" },
};

export function LogoMark({ size = "sm", className = "" }) {
  const s = SIZE[size];
  return (
    <span
      className={`${s.box} rounded-lg bg-white border border-slate-200 grid place-items-center flex-shrink-0 ${className}`}
      aria-hidden
    >
      <img
        src={SOLEMNITY_LOGO_URL}
        alt=""
        className={`${s.img} object-contain`}
        loading="eager"
      />
    </span>
  );
}

export function BrandLockup({ size = "sm", showSub = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <div className="leading-tight">
        <div className="text-base font-semibold text-slate-900 tracking-tight">
          {BRAND.short}
        </div>
        {showSub && (
          <div className="text-[10px] tracking-[0.14em] uppercase text-slate-500">
            IT Healthcare · Pvt Ltd
          </div>
        )}
      </div>
    </div>
  );
}
